module.exports = __webpack_public_path__ + "img/img_e_brand_up_color_png.9f4e8f37.png";